import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const Elevator = (props) => {
  const { height, width, fill, className } = props;
  return (
    <svg
      id="elevator"
      width={width}
      height={height}
      stroke="none"
      className={className}
      viewBox="0 0 60 60"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M44.13 18.044H31.087v34.782H44.13V18.044zM28.913 18.044H15.87v34.782h13.043V18.044z" />
      <path d="M53.913 5H6.087C5.487 5 5 5.487 5 6.087v47.826c0 .6.487 1.087 1.087 1.087h7.609V16.956c0-.6.487-1.086 1.087-1.086h30.435c.6 0 1.086.487 1.086 1.086V55h7.609c.6 0 1.087-.487 1.087-1.087V6.087C55 5.487 54.513 5 53.913 5zm-27.491 8.378a1.092 1.092 0 01-1.54 0l-1.404-1.406-1.404 1.406a1.088 1.088 0 01-1.537-1.537l2.174-2.174a1.088 1.088 0 011.537 0l2.174 2.174c.424.424.424 1.111 0 1.537zm13.043-2.174l-2.174 2.174a1.092 1.092 0 01-1.539 0l-2.174-2.174a1.088 1.088 0 011.537-1.537l1.407 1.405 1.404-1.405a1.088 1.088 0 011.54 1.537zm10.1 22.057a1.087 1.087 0 11.001-2.175 1.087 1.087 0 010 2.175zm0-4.348a1.087 1.087 0 11.001-2.175 1.087 1.087 0 010 2.175z" />
    </svg>
  );
};
/* eslint-enable max-len */

Elevator.defaultProps = {
  className: null,
};

Elevator.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default Elevator;
